export default "__VITE_ASSET__RbG3sdGQ__"